(function ($, window, Drupal, once) {
	Drupal.behaviors.standartCarousel = {
	  	attach: function (context, settings) {
      	    once('standartCarouselBehavior', 'html', context).forEach( function (element) { 
            //jQuery(document).ready(function($){

                const iOS_1to12 = /iPad|iPhone|iPod/.test(navigator.platform);
                const iOS13_iPad = (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
                const iOS1to12quirk = function() {
                    var audio = new Audio(); // temporary Audio object
                    audio.volume = 0.5; // has no effect on iOS <= 12
                    return audio.volume === 1;
                };
                
                const isIOS = !window.MSStream && (iOS_1to12 || iOS13_iPad || iOS1to12quirk());

                if (isIOS) {
                    $('.paragraph-mdi-module').each(function(){
                        $(this).parents('.layout--card').remove();
                    });
                }

                if ($('.layout-builder-form').length  == 0) {

                    var rtl = false;
                    if ($('.rtl-direction').length > 0) {
                        rtl = true;
                    }

                    $('.tabs-carousel .nav-tabs').each(function(index){
                        let owltabs = $(this);
                        owltabs.addClass('owl-carousel');
                        let owlnavstab = owltabs.find('a[data-toggle="tab"]');
                        let tabscount = owlnavstab.length;             
                        if (tabscount <= 3) {
                            var owlOptions = {
                                rtl:rtl,
                                stagePadding:15,
                                margin:24,
                                loop:false,                      
                                lazyLoad:false,
                                nav:true,
                                dots:false,
                                onInitialized: carouselInitialized,	
                                onChanged: function(event){ 
                                    $(event.target).find('.owl-stage').children().removeClass('current');
                                    let first = true;
                                    for (var i = event.item.index, p = event.page.size; p > 0; i++, p--){
                                        let currentslide = $(event.target).find('.owl-stage').children(':eq('+i+')');
                                        currentslide.addClass('current');   
                                        if (first) {  
                                            $('.tabs-carousel .nav-tabs .owl-item a').removeClass('active');
                                            currentslide.find('a').click();
                                        }
                                        first = false;
                                    }
                                },
                                responsive: {
                                    0: {
                                        items:1, 
                                        margin:24,                        
                                    },
                                    768: {
                                        items:2, 
                                        margin:15,                       
                                    }, 
                                    992 : {
                                        items:3,
                                        stagePadding:10,
                                    },            
                                }
                            };

                            if (window.innerWidth < 992) {
                                var owlTabsActive = owltabs.owlCarousel(owlOptions);
                            } else {
                                owltabs.addClass('off');
                            }         

                            $(window).resize(function () {
                                if (window.innerWidth < 992) {
                                    if (owltabs.hasClass('off')) {
                                        var owlTabsActive = owltabs.owlCarousel(owlOptions);
                                        owltabs.removeClass('off');
                                    }
                                } else {
                                    if (!owltabs.hasClass('off')) {
                                        owltabs.addClass('off').trigger('destroy.owl.carousel');
                                        owltabs.find('.owl-stage-outer').children(':eq(0)').unwrap();
                                    }
                                }
                            });

                            function carouselInitialized(event){
                                $('.tabs-carousel .nav-tabs .owl-stage').on('click',$('.owl-item a'),function(e){
                                    $('.tabs-carousel .nav-tabs .owl-item a').removeClass('active');
                                    $(this).addClass('active');
                                });
                            }                                    
                        }
                    });

                    $('.owl-carousel').not('.carousel-all-off').each(function(index){
                        var owl = $(this);
                
                        owl.find('.block .paragraph--type--md-slides.d-none, .block .paragraph--type--mdt-slides.d-none').each(function(){
                            $(this).closest('.block').remove();
                        });
                    
                        var dotsBlock = '<div class="owl-dots horizontal-slides-dots"></div>';
                        if (owl.hasClass('horizontal-cards')) {

                            var mdtcardcount = owl.find('.mdt-horizontal-cards-card').length;

                            if (mdtcardcount > 0) {     

                                if (mdtcardcount <=3) { 
                                    owl.addClass('mdt-horizontal-cards');
                                    var idCarouselDots = '#' + owl.parent().attr('id') + ' .horizontal-slides-dots';
                                    var owlOptions = {
                                        rtl:rtl,
                                        stagePadding:15,
                                        loop:false,                      
                                        lazyLoad:false,
                                        nav:true,
                                        dots:true,
                                        dotsContainer:idCarouselDots,
                                        onChanged: function(event){
                                            $(event.target).find('.owl-stage').children().removeClass('current');
                                            for (var i = event.item.index, p = event.page.size; p > 0; i++, p--){
                                            $(event.target).find('.owl-stage').children(':eq('+i+')').addClass('current');
                                            }
                                        },
                                        responsive: {
                                            0: {
                                                items:1,
                                                margin:15
                                            },
                                            576: {
                                                items:2,
                                                margin:10
                                            },           
                                        }
                                    };                   
                                    if (window.innerWidth < 992) {
                                        owl.after(dotsBlock);
                                        var owlActive = owl.owlCarousel(owlOptions);
                                    } else {
                                        owl.addClass('off');
                                    }         
                                    $(window).resize(function () {
                                        if (window.innerWidth < 992) {
                                            if (owl.hasClass('off')) {
                                                owl.removeClass('off');
                                                owl.after(dotsBlock);
                                                var owlActive = owl.owlCarousel(owlOptions);                                  
                                            }
                                        } else {
                                            if (!owl.hasClass('off')) {
                                                owl.addClass('off').trigger('destroy.owl.carousel');
                                                owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
                                            }
                                        }
                                    });
                                } else if (mdtcardcount == 4) {
                                    owl.addClass('mdt-horizontal-cards');
                                    var idCarouselDots = '#' + owl.parent().attr('id') + ' .horizontal-slides-dots';
                                    var owlOptions = {
                                        rtl:rtl,
                                        stagePadding:15,
                                        loop:false,                      
                                        lazyLoad:false,
                                        nav:true,
                                        dots:true,
                                        dotsContainer:idCarouselDots,
                                        onChanged: function(event){
                                            $(event.target).find('.owl-stage').children().removeClass('current');
                                            for (var i = event.item.index, p = event.page.size; p > 0; i++, p--){
                                            $(event.target).find('.owl-stage').children(':eq('+i+')').addClass('current');
                                            }
                                        },
                                        responsive: {
                                            0: {
                                                items:1,
                                                margin:15
                                            },
                                            576: {
                                                items:2,
                                                margin:10
                                            },
                                            992 : {
                                                items:3,
                                                stagePadding:10,
                                            },            
                                        }
                                    };                   
                                    if (window.innerWidth < 1290) {
                                        owl.after(dotsBlock);
                                        var owlActive = owl.owlCarousel(owlOptions);
                                    } else {
                                        owl.addClass('off');
                                    }         
                                    $(window).resize(function () {
                                        if (window.innerWidth < 1290) {
                                            if (owl.hasClass('off')) {
                                                owl.removeClass('off');
                                                owl.after(dotsBlock);
                                                var owlActive = owl.owlCarousel(owlOptions);                           
                                            }
                                        } else {
                                            if (!owl.hasClass('off')) {
                                                owl.addClass('off').trigger('destroy.owl.carousel');
                                                owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
                                            }
                                        }
                                    });
                                }                  
                            } else {       
                    
                                if (owl.find('.horizontal-cards-card').length == 4) {                         
                                    var respslide = {
                                        0: {
                                            items:1,
                                            margin:15,
                                            stagePadding:15,
                                        },
                                        768: {
                                            items:2,
                                            margin:0,
                                            stagePadding:21,
                                        },
                                        992 : {
                                            items:3,
                                            margin:0,
                                            stagePadding:21,
                                        },  
                                    };
                                    var offwidth = 1290;
                                } else {
                                    var respslide = {
                                        0: {
                                            items:1,
                                            margin:15,
                                            stagePadding:15,                   
                                        },
                                        768: {
                                            items:2,
                                            margin:0,
                                            stagePadding:21,
                                        }   
                                    };
                                    var offwidth = 992;
                                }
                            
                                var idCarouselDots = '#' + owl.parent().attr('id') + ' .horizontal-slides-dots';

                                var owlOptions = {
                                    rtl:rtl,
                                    loop:false,
                                    lazyLoad:false,
                                    nav:true,
                                    dots:true,
                                    dotsContainer: idCarouselDots,
                                    responsive: respslide,
                                    onChanged: function(event){
                                        $(event.target).find('.owl-stage').children().removeClass('current');
                                        for (var i = event.item.index, p = event.page.size; p > 0; i++, p--){
                                        $(event.target).find('.owl-stage').children(':eq('+i+')').addClass('current');
                                        }
                                    }, 
                                };
                        
                                if (window.innerWidth < offwidth) {
                                    owl.after(dotsBlock);
                                    var owlActive = owl.owlCarousel(owlOptions);
                                } else {
                                    owl.addClass('off');
                                }
                        
                                $(window).resize(function () {
                                    if (window.innerWidth < offwidth) {
                                        if (owl.hasClass('off')) {
                                            owl.removeClass('off');
                                            owl.after(dotsBlock);
                                            var owlActive = owl.owlCarousel(owlOptions);
                                        }
                                    } else {
                                        if (!owl.hasClass('off')) {
                                            owl.addClass('off').trigger('destroy.owl.carousel');
                                            owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
                                        }
                                    }
                                });
                        
                            }

                        } else if (owl.hasClass('horizontal-cards-v2')){
                            var citems = owl.find('.mdt-horizontal-cards-card').length;
                            var idCarouselDots = '#' + owl.parent().attr('id') + ' .horizontal-slides-dots';
                            var owlOptions3 = {                     
                                rtl: rtl,
                                stagePadding:24,
                                loop:false,
                                margin:0,
                                lazyLoad:false,
                                nav:true,
                                dotsContainer: idCarouselDots,
                                onChanged: function(event){
                                    $(event.target).find('.owl-stage').children().removeClass('current');
                                    for (var i = event.item.index, p = event.page.size; p > 0; i++, p--){
                                    $(event.target).find('.owl-stage').children(':eq('+i+')').addClass('current');
                                    }
                                },
                                responsive: {0:{ items:1 }, 768: { items:2 }, 1060: { items:3 } },
                            };

                            if (citems > 3) {
                                owl.after(dotsBlock);
                                var owlActive = owl.owlCarousel(owlOptions3);
                            } else if (citems == 3) { 
                                if (window.innerWidth < 992) {
                                    owl.after(dotsBlock);
                                    var owlActive = owl.owlCarousel(owlOptions3);
                                } else {
                                    owl.addClass('off');
                                }
                                $(window).resize(function () {
                                    if (window.innerWidth < 992) {
                                        if (owl.hasClass('off')) {
                                            owl.after(dotsBlock);
                                            var owlActive = owl.owlCarousel(owlOptions3);
                                            owl.removeClass('off');
                                        }
                                    } else {
                                        if (!owl.hasClass('off')) {
                                            owl.addClass('off').trigger('destroy.owl.carousel');
                                            owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
                                        }
                                    }
                                });  

                            } else if (citems == 2) {
                            
                                var owlOptions = {                     
                                    rtl: rtl,
                                    stagePadding:24,
                                    loop:false,
                                    margin:0,
                                    lazyLoad:false,
                                    nav:true,
                                    dotsContainer: idCarouselDots,
                                    onChanged: function(event){
                                        $(event.target).find('.owl-stage').children().removeClass('current');
                                        for (var i = event.item.index, p = event.page.size; p > 0; i++, p--){
                                        $(event.target).find('.owl-stage').children(':eq('+i+')').addClass('current');
                                        }
                                    },
                                    responsive: {0:{ items:1 }},
                                }; 
                                if (window.innerWidth < 768) {
                                    owl.after(dotsBlock);
                                    var owlActive = owl.owlCarousel(owlOptions);
                                } else {
                                    owl.addClass('off');
                                }   

                                $(window).resize(function () {
                                    if (window.innerWidth < 768) {
                                        if (owl.hasClass('off')) {
                                            owl.after(dotsBlock);
                                            var owlActive = owl.owlCarousel(owlOptions);
                                            owl.removeClass('off');
                                        }
                                    } else {
                                        if (!owl.hasClass('off')) {
                                            owl.addClass('off').trigger('destroy.owl.carousel');
                                            owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
                                        }
                                    }
                                });  

                            } else {
                                owl.addClass('off');
                            }

                        } else if (owl.hasClass('mdt-components')) {               
                            if (!Object.getOwnPropertyDescriptor(Element.prototype,'classList')){
                                if (HTMLElement&&Object.getOwnPropertyDescriptor(HTMLElement.prototype,'classList')){
                                    Object.defineProperty(Element.prototype,'classList',Object.getOwnPropertyDescriptor(HTMLElement.prototype,'classList'));
                                }
                            };
                            //polyfill for Array.from
                            if (!Array.from) {
                                Array.from = (function() {
                                var toStr = Object.prototype.toString;
                                var isCallable = function(fn) {
                                    return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
                                };
                                var toInteger = function (value) {
                                    var number = Number(value);
                                    if (isNaN(number)) { return 0; }
                                    if (number === 0 || !isFinite(number)) { return number; }
                                    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
                                };
                                var maxSafeInteger = Math.pow(2, 53) - 1;
                                var toLength = function (value) {
                                    var len = toInteger(value);
                                    return Math.min(Math.max(len, 0), maxSafeInteger);
                                };                  
                                return function from(arrayLike/*, mapFn, thisArg */) {
                                    var C = this;                 
                                    var items = Object(arrayLike);                 
                                    if (arrayLike == null) {
                                    throw new TypeError('Array.from requires an array-like object - not null or undefined');
                                    }                 
                                    var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                                    var T;
                                    if (typeof mapFn !== 'undefined') {
                                    if (!isCallable(mapFn)) {
                                        throw new TypeError('Array.from: when provided, the second argument must be a function');
                                    }
                                    if (arguments.length > 2) {
                                        T = arguments[2];
                                    }
                                    }
                                    var len = toLength(items.length);
                                    var A = isCallable(C) ? Object(new C(len)) : new Array(len);
                                    var k = 0;
                                    var kValue;
                                    while (k < len) {
                                    kValue = items[k];
                                    if (mapFn) {
                                        A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                                    } else {
                                        A[k] = kValue;
                                    }
                                    k += 1;
                                    }
                                    A.length = len;
                                    return A;
                                };
                                }());
                            };

                            var cPointer = $('.components-pointer');

                            var owlOptions = { 
                                rtl:rtl,
                                items:1,
                                loop:true,
                                mouseDrag:false,
                                touchDrag:false,
                                pullDrag:false,
                                rewind:true,
                                autoplay:false,
                                margin:0,
                                nav:true,
                                dots:true,             
                            };

                            owl.on('initialized.owl.carousel', function(e){
                                owl.show();
                            });

                            cPointer.on('click',function () {
                                var owlActive = owl.owlCarousel(owlOptions);
                                var id = this.id,
                                index = this.getAttribute('index'),
                                cross=this.querySelector('.cross'),
                                pointer = document.querySelector(".img-with-pointers .components-pointer#btn-circle-"+index),
                                mpointer = document.querySelector(".mobile-img-with-pointers .components-pointer#m-btn-circle-"+index),
                                arr = document.getElementById('system-components').getElementsByClassName('cross');
                                if (cross.classList.contains('active')) {       
                                    cross.classList.remove('active');
                                    owl.hide();
                                    owl.trigger('destroy.owl.carousel');
                                } else {
                                    var owlActive = owl.owlCarousel(owlOptions);
                                    Array.from(arr).forEach(function (el) { el.classList.remove('active');});
                                    pointer.querySelector(".cross").classList.add("active");
                                    mpointer.querySelector(".cross").classList.add("active");
                                    owl.trigger('to.owl.carousel', [index,100]); 
                                };
                                if (document.body.clientWidth < 992 && cross.classList.contains("active"))  {
                                    var elPos = jQuery(".mdt-components").offset().top;
                                    $('html, body').animate({scrollTop: (parseInt(elPos)) - window.innerHeight/3}, 200);
                                }
                            });

                            owl.on('translated.owl.carousel', function(e){
                                var id = this.querySelector(".owl-item.active").querySelector(".component-slide").id,
                                pointer = document.querySelector(".img-with-pointers .components-pointer#btn-circle-"+id),
                                mpointer = document.querySelector(".mobile-img-with-pointers .components-pointer#m-btn-circle-"+id);
                                deactivate_pointer();
                                pointer.querySelector(".cross").classList.add("active");
                                mpointer.querySelector(".cross").classList.add("active");
                            });

                            $('#system-components svg.close-button').click(function () {
                                owl.hide();
                                deactivate_pointer();
                                owl.trigger('destroy.owl.carousel');
                            });

                            function deactivate_pointer(){
                                var arr = document.getElementById('system-components').getElementsByClassName('cross');
                                Array.from(arr).forEach(function (el) { el.classList.remove('active');});
                            };
                            
                        } else if (owl.hasClass('mdi-module-carousel')) {
                            if (window.dataLayer = window.dataLayer || []) {
                                var owlOptions = {
                                    rtl:rtl, 
                                    items:1,
                                    loop:false,
                                    rewind:true,
                                    mouseDrag:false,
                                    touchDrag:false,
                                    pullDrag:false,                           
                                    lazyLoad:false,
                                    autoplay:false,
                                    margin:0,
                                    nav:false,
                                    dots:false,
                                    onTranslated: function(event){                  
                                        for (var i=(event.item.index+1); i< event.item.count; i++) {
                                            owl.trigger('remove.owl.carousel', [i]).trigger('refresh.owl.carousel');       
                                        }
                                        owl.find('.mdt-mdi-slide').removeClass('new-insert');                                          
                                    } 
                                };   

                                var owlActive = owl.owlCarousel(owlOptions);    
                                var firstslide = owl.find('.active .mdt-mdi-slide');             
                                var f_prefix_q = firstslide.find('.prefix-mdi-module-question p').text();
                                
                                $(".paragraph-mdi-module").viewportChecker({
                                    offset:'50%',
                                    invertBottomOffset: true,
                                    repeat: true,
                                    callbackFunction: function(elem, action){
                                        if (action == 'add') {
                                            if (elem.hasClass('first-look')) {
                                                elem.removeClass('first-look');
                                                dataLayer.push({'event':'gaView','virtualPagePath':'/step1','virtualPageTitle':f_prefix_q}); 
                                            }
                                        }
                                    },
                                    scrollHorizontal: false 
                                });

                                $("body").on('click','.mdi-custom-select-wrapper',function() {
                                    var item = $(this).get(0);
                                    item.querySelector('.mdi-custom-select').classList.toggle('open');
                                });
                                $("body").on('click','.mdi-close-result',function() {     
                                    var countitems = owl.find('.owl-item').length-1;
                                    for (var i=countitems; i>=1; i--) {
                                        owl.trigger('remove.owl.carousel', [i]);       
                                    }
                                    owl.trigger('refresh.owl.carousel');
                                    var fslide = owl.find('.mdt-mdi-slide');
                                    fslide.addClass('fixed-point');
                                    fslide.find('.dropdown-menu .dropdown-item-0 span').trigger('click')
                                    fslide.find('.mdi-card-next-btn').prop("disabled", true).attr('disabled','disabled');                 
                                    dataLayer.push({'event':'gaEvent', 'eventCategory':'mdiModule', 'eventAction':'result', 'eventLabel': $(this).attr('data-title-gtm')+'-makeANewSearch'});
                                    dataLayer.push({'event':'gaView','virtualPagePath':'/step1','virtualPageTitle':f_prefix_q});
                                });           
                                $("body").on('click','.start-discovering-btn',function() {
                                    dataLayer.push({'event':'gaEvent', 'eventCategory':'mdiModule', 'eventAction':'result', 'eventLabel':$(this).attr('data-title-gtm')});
                                });
                                function wrapWords(str, tmpl) {
                                    return str.replace(/(^|<\/?[^>]+>|\s+)([^\s<]+)/g, tmpl || "<span>$&</span>").slice(0, -7) + '<span class="wrap-arrow"><span class="arrow"></span></span></span>';
                                }
                                $(".paragraph-mdi-module .wrap-gallery").on('click', '.dropdown-menu-option li span', function() {
                                    var sel =  wrapWords($(this).text());                    
                                    var slide = $(this).parents('.mdt-mdi-slide');
                                    var eq = $(this).parent().attr('data-eq');
                                    var dropparent = $(this).parents('.dropdown-menu-option');
                                    var dropid = dropparent.attr('data-dropid');
                                    $('.wrap-gallery ul[data-dropid="'+dropid+'"]'+' li span').removeClass('active');
                                    var sid = $(this).attr('data-value');
                                    $('.wrap-gallery ul[data-dropid="'+dropid+'"]'+' .dropdown-item-'+eq+' span').addClass('active');
                                    var droptxt = $('.wrap-gallery #'+dropparent.attr('data-dropid')+' .dropdown-item-text');
                                    droptxt.removeClass('default-option').html(sel);
                                    droptxt.data('data-value', sid).attr('data-value', sid);
                                    var nextbtn = slide.find('.mdi-card-next-btn');
                                    nextbtn.removeClass('last-default-option');
                                    if ($(this).parents('.last-step').length > 0) {
                                        nextbtn.data('data-target', '#mdi-result-sid-'+sid).attr('data-target','#mdi-result-sid-'+sid);
                                    } 
                                    nextbtn.prop("disabled", false);
                                    nextbtn.removeAttr('disabled');
                                });        
                                $(".paragraph-mdi-module .wrap-gallery").on('click', '.dropdown-item-text[data-value="0"]', function() {
                                    dataLayer.push({'event':'gaEvent', 'eventCategory':'mdiModule', 'eventAction':'step0', 'eventLabel':'choose one'});
                                });

                                $('.mdi-card-next-btn').prop("disabled", true);

                                $('.dropdown-options').on('show.bs.dropdown', function () {
                                    $(this).parents('.owl-carousel').addClass('open-dropdown');
                                });
                            
                                $('.dropdown-options').on('hide.bs.dropdown', function () {
                                    setTimeout(function() {
                                        $(this).parents('.owl-carousel').removeClass('open-dropdown');
                                    }, 300);
                                });

                                $("body").on('click','.mdi-card-next-btn', function() {
                                    var step = parseInt($(this).attr('data-step'));
                                    var currentoption = owl.find('.active .mdt-mdi-slide .dropdown-option.active').text();   
                                    
                                    if ($(this).hasClass('last-default-option')) {
                                        currentoption = 'unselected';
                                    }

                                    if (step == '1') {
                                        dataLayer.push({'event':'gaEvent', 'eventCategory':'mdiModule', 'eventAction':'step1', 'eventLabel': currentoption});                 
                                    } else if (step == '2') {                                            
                                        dataLayer.push({'event':'gaEvent', 'eventCategory':'mdiModule', 'eventAction':'step2', 'eventLabel': currentoption});                    
                                    } else if (step == '3') {             
                                        dataLayer.push({'event':'gaEvent', 'eventCategory':'mdiModule', 'eventAction':'step3', 'eventLabel': currentoption});                    
                                    }
                                    if (!$(this).hasClass('mdi-result-btn')) {  
                                        $(this).parents('.owl-carousel').removeClass('open-dropdown');                  
                                        var sid = $(this).parents('.' + $(this).data('target')).find('.dropdown-item-text').attr('data-value');               
                                        var nextslide = $('.paragraph--type--mdt-mdi-module-cards.sid-'+sid).first();
                                        if (nextslide.length > 0 && step >= 1) {                                                              
                                            owl.trigger('add.owl.carousel', [nextslide.html()]);
                                            owl.trigger('to.owl.carousel', step-1); 
                                            owl.trigger('to.owl.carousel', [step,600]); 
                                            owl.find('.mdt-mdi-slide').removeClass('left-dir fixed-point').addClass('right-dir');
                                            var activeslide = owl.find('.active .mdt-mdi-slide');
                                            var nextstep = step+1;
                                            var prefix_q = activeslide.find('.prefix-mdi-module-question p').text();
                                            dataLayer.push({'event':'gaView','virtualPagePath':'/step'+nextstep,'virtualPageTitle':prefix_q}); 
                                            activeslide.addClass('left-dir'); 
                                            var activsid = activeslide.find('.dropdown-item-text').attr('data-value');
                                            if (activsid > 0) {
                                                var nextbtn = activeslide.find('.mdi-card-next-btn');
                                                if (activeslide.hasClass('last-step')) {
                                                    nextbtn.data('data-target', '#mdi-result-sid-'+activsid).attr('data-target','#mdi-result-sid-'+activsid);
                                                }
                                                nextbtn.prop("disabled", false);
                                                nextbtn.removeAttr('disabled');
                                            }
                                            $('.dropdown-options').off('show.bs.dropdown');
                                            $('.dropdown-options').off('hide.bs.dropdown');
                                            $('.dropdown-options').on('show.bs.dropdown', function () {
                                                $(this).parents('.owl-carousel').addClass('open-dropdown');
                                            });
                                            $('.dropdown-options').on('hide.bs.dropdown', function () { 
                                                setTimeout(function() {
                                                    $(this).parents('.owl-carousel').removeClass('open-dropdown');
                                                }, 300);    
                                            }); 
                                        }
                                    }
                                });

                                $("body").on('click','.mdi-card-prev-btn', function() {
                                    var carousel =  $(this).parents('.owl-carousel');
                                    var step = carousel.find('.owl-item.active .current-step').text();
                                    carousel.removeClass('open-dropdown');
                                    owl.find('.mdt-mdi-slide').addClass('right-dir');   
                                    owl.trigger('prev.owl.carousel', [600]);
                                    dataLayer.push({'event':'gaEvent', 'eventCategory':'mdiModule', 'eventAction':'step'+step, 'eventLabel': 'goBack'});
                                });
                            }

                        } else if (owl.hasClass('mdt-tab-slider')) {
                            var owlOptions = { 
                                rtl:rtl,
                                items: 1,
                                loop: true,
                                mouseDrag: true,
                                touchDrag: true,
                                pullDrag: false,
                                rewind: true,
                                autoplay: true,
                                autoplayTimeout: 5000, 
                                margin: 0,
                                transitionStyle : "fade",
                                animateOut: 'fadeOut',
                                nav: false            
                            };
                            
                            var owlActive = owl.owlCarousel(owlOptions);
                        } else if (owl.hasClass('mdt-paragraph-carousel-testimonials')) {
                            var mdtcardcount = owl.find('.paragraph-mdt-text-with-image').length;
                            if (mdtcardcount > 1) {
                                var owlOptions = { 
                                    rtl:rtl,
                                    items:1,
                                    dots:true,
                                    dotsContainer:'.testimonials-dots',
                                    mouseDrag:true,
                                    touchDrag:true,
                                    pullDrag:false,
                                    margin:0,
                                    transitionStyle :"fade",
                                    animateIn:'fadeIn',
                                    animateOut:'fadeOut',
                                    nav:true         
                                };
                                var owlActive = owl.owlCarousel(owlOptions);
                            }
                        } else if (owl.hasClass('image-slide-cards')) {
                            var owlOptions = {
                                rtl:rtl,                 
                                dots:true,
                                mouseDrag:true,
                                touchDrag:true,
                                pullDrag:false,
                                margin:0,
                                lazyLoad:false,
                                nav:true,
                                responsive: {
                                    0: {
                                        items:1.7,
                                        loop:true,
                                    },
                                    768: {
                                        items:2,
                                        loop:false,
                                    },
                                    992 : {
                                        items:3,
                                        loop:false,
                                        mouseDrag:false,
                                    }, 
                                }          
                            };
                            var owlActive = owl.owlCarousel(owlOptions);
                        } else if (owl.hasClass('owl-carousel-app-1')) {
                            var sync1 = owl, sync2 = $('.owl-carousel-app-2');
                            var flag = false;
                            var duration = 300;

                            sync1.owlCarousel({
                                rtl:rtl,
                                loop:false,
                                items:1,
                                margin:0,
                                nav:false,
                                dots:false, 
                                rewind:true,                   
                                transitionStyle:"fade",
                                animateOut:'fadeOut',  
                                mouseDrag: false,
                                touchDrag: false,
                                pullDrag: false,               
                            }).on('changed.owl.carousel', function (e) {
                                if (!flag) {
                                    flag = true;
                                    sync2.trigger('to.owl.carousel', [e.item.index, duration, true]);
                                    flag = false;
                                }
                            });
                            
                            sync2.owlCarousel({
                                rtl:rtl,
                                loop:false,
                                items:1,
                                margin:0,
                                nav:true,
                                rewind:true,
                                dotsContainer:'.app-dots',
                                autoplay:true,
                                autoplayTimeout:8000,
                                autoplayHoverPause:true,
                                stopOnHover:true,
                            }).on('changed.owl.carousel', function (e) {
                                if (!flag) {
                                    flag = true;        
                                    sync1.trigger('to.owl.carousel', [e.item.index, duration, true]);
                                    flag = false;
                                }
                            });
                            
                        }
                    });
                }
           // });  
        });
    }
  }
  
} (jQuery, window, Drupal, once));